import React from 'react';

import { classnames } from '../../utils';
import styles from './Alert.module.scss';

/**
 * Alert container.
 *
 * @typedef {"info"|"warning"|"error"|"success"} AlertVariant
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children
 * @param {AlertVariant} [props.variant]
 * @param {string} [props.className]
 * @returns JSX.Element
 */
const Alert = ({ children, variant = 'info', className = '' }) => {
	return (
		<div className={classnames(styles.container, styles[variant], className)} role="alert">
			{children}
		</div>
	);
};

export default Alert;
